import React, { useEffect } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useHistory, useParams } from 'react-router-dom';
import { Grid, List, ListItem, ListItemText, Divider } from '@material-ui/core';
import { Amount, Page, AppBar, ScreenLoader } from 'components';
import { ru } from 'locale';
import { formatDate, fullDateFormat } from 'utils/date';
import { anketsStore, caseStore } from 'stores';
import { CaseSides, Documents } from './components';
import useStyles from './CaseScreen.styles';

const CaseScreen = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const { caseId } = useParams();
  const caseNumber = decodeURIComponent(caseId);
  const { fetchState, caseData, sides } = caseStore;

  useEffect(
    () =>
      autorun(() => {
        caseStore.getCase(anketsStore.anketId, caseNumber);
      }),
    [caseNumber],
  );

  const handleBackClick = () => {
    history.goBack();
  };

  const renderAmount = value => {
    return <Amount color="inherit" amount={{ value, currency: { code: 'RUR', minority: 0 } }} />;
  };

  const renderCase = () => {
    const startDate = formatDate(caseData.startDate, fullDateFormat);

    return (
      <List component="nav" aria-label={ru.case} className={classes.list}>
        <ListItem component="div">
          <ListItemText primary={startDate} secondary={caseData.caseCategory} />
        </ListItem>
        <Divider />
        <ListItem component="div">
          <ListItemText
            primary={ru.claimAmount}
            secondary={renderAmount(caseData.claimAmount)}
            classes={{ secondary: classes.claimAmount }}
          />
        </ListItem>
        <Divider />
        <ListItem component="div">
          <ListItemText primary={ru.decision} secondary={caseData.result} />
        </ListItem>
        <Divider />

        <CaseSides sides={sides} />

        <Documents documents={caseData.documents} />
      </List>
    );
  };

  return (
    <Page fullScreen style={{ minHeight: '100rvh' }}>
      <Grid container direction="column">
        <AppBar title={caseNumber} onNavButtonClick={handleBackClick} />

        {fetchState === 'pending' && <ScreenLoader />}

        <Grid container item direction="column">
          {fetchState === 'fulfilled' && renderCase()}
        </Grid>
      </Grid>
    </Page>
  );
});

export default CaseScreen;
